<template>
    <div>
        <!-- <img src="../../assets/img/logo-opacity.png" class="logo-opacity" /> -->
        <!-- <img src="static/logo.png" class="logo" /> -->
        <h2 style="margin-left: 30px;">设备全生命周期管理系统</h2>
        <div class="content">

            <p>工卡号码</p>
            <Input type="text" placeholder="请输入工卡号码" @change="change(arguments[0],'user')" @enter="focusIndex = 2"
                :inputFocus="focusIndex === 1" />
            <p>密码</p>
            <Input type="password" placeholder="请输入密码" @change="change(arguments[0],'password')" @enter="login"
                :inputFocus="focusIndex === 2" />
        </div>
        <div class="login" @click="login">登录</div>
        <!-- <div class="copyright">
            <p>Copyright ©2022-{{$format(new Date(),'YYYY')}}</p>
            <p>
                <a target="_blank" href="http://www.huiyxx.com/" style="color:#4c4c4c;">某某公司</a>
            </p>
            <p>All Rights Reserved</p>
            <p>技术支持：189 7920 2829</p>
            <p>
                <a target="_blank" href="https://beian.miit.gov.cn/" style="color:#4c4c4c;">粤ICP备2022052272号-1</a>
            </p>
            <p>
                <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030702004772"
                    style="display:inline-block;text-decoration:none;height:20px;line-height:20px;text-align: center;">
                    <img src="../../assets/img//ForTheRecord.png" style="float:left;" />
                    <p style="color:#4c4c4c;float:left;height:20px;line-height:20px; ">粤公网安备 44030702004772号</p>
                </a>
            </p>
        </div> -->
    </div>
</template>

<script>
    import config from "../../../config/index.js";
    import Vue from "vue";
    import Input from "@/components/input/input";
    export default {
        name: "login",
        data() {
            return {
                code: null,
                user: null,
                password: null,
                focusIndex: null
            };
        },
        components: {
            Input
        },
        mounted() {},
        methods: {
            change(value, type) {
                this[type] = value;
            },
            login() {
                const showText = !this.user ?
                    "请输入登录用户名!" :
                    !this.password ?
                    "请输入登录密码!" :
                    null;
                if (showText) this.$Toast(showText);
                else {
                    var ClientInfo = this.$store.getters.ClientInfo;
                    if (!ClientInfo.clientid && !config.PresentType) {
                        //判断ClientId
                        this.$Toast({
                            message: "获取APP信息异常或网络未连接",
                            duration: 2000
                        });
                        return false;
                    }
                    this.$get("api/Login/loginForH5", {
                        ClientId: ClientInfo.clientid ? ClientInfo.clientid : "",
                        UserCode: this.user,
                        Password: this.password
                    }).then(result => {
                        if (result == undefined) {
                            this.$Toast("请求错误");
                        } else {
                            if (result.Code === "10000") {
                                result.UserId = String.trim(result.UserId);
                                Vue.prototype.$UserInfo = result;
                                localStorage.setItem("userInfo", JSON.stringify(result));
                                this.$store.commit("SET_HOMEDESKTOP", []); //清除首页列表缓存
                                localStorage.setItem("token", result.Access_Token);
                                this.$router.push("/STORE");
                            } else {
                                this.$Toast(result.Msg);
                            }
                        }
                    });
                }
            }
        }
    };
</script>

<style lang="scss" scoped>
    .logo-opacity {
        position: absolute;
        top: -280px;
        right: -180px;
        width: 600px;
        height: 600px;
    }

    .logo {
        width: 258px;
        height: 144px;
        margin-top: 129px;
        margin-left: 52px;
    }

    .content {
        margin-top: 30px;
        padding: 0 70px;
        box-sizing: border-box;

        p {
            font-size: 30px;
            color: $TEXT-DARK-COLOR;
            font-weight: 500;
        }
    }

    .login {
        width: 600px;
        height: 100px;
        border-radius: 12px;
        background: $THEME-COLOR;
        line-height: 100px;
        text-align: center;
        font-size: 32px;
        color: $TEXT-LIGHT-COLOR;
        margin-left: 70px;
        margin-top: 25vw;
    }

    .copyright {
        margin-top: 34vw;

        &>p {
            text-align: center;
            color: #4c4c4c;
            font-size: 3vw;
        }
    }
</style>



// WEBPACK FOOTER //
// src/page/login/login.vue